import React from 'react';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { RiCheckboxCircleFill } from 'react-icons/ri';
import {Link, useSearchParams} from 'react-router-dom'
const PaymentSuccess = () => {
  const search=useSearchParams()[0].get("reference")
  const courseId=useSearchParams()[0].get("courseId")
  return (
    <Container h="100vh" p="16">
      <Heading my="8" textAlign={'center'}>
        You have Pro Pack
      </Heading>
      <VStack boxShadow={'lg'} pb="16" alignItems={'center'} borderRadius="lg">
        <Box
          w="full"
          bg="yellow.400"
          p="4"
          css={{ borderRadius: '8px 8px 0 0' }}
        >
          <Text color="black">Payment Success</Text>
        </Box>
        <Box p="4">
          <VStack textAlign={'center'} px="8" mt="4" spacing="8">
            <Text>
              Congratulation you're a pro member. You have access to premium
              content.
            </Text>
            <Heading size="4xl">
              <RiCheckboxCircleFill />
            </Heading>
          </VStack>
        </Box>
        <Link to={`/course/${courseId}`}>
          <Button variant={'ghost'}>Go To Course</Button>
        </Link >
        <Heading size="xs">{`Reference: ${search}`}</Heading>
      </VStack>
    </Container>
  );
};

export default PaymentSuccess;
